import React from 'react';

import { Card, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import InputSearch from 'common/components/InputSearch';

const BulkOperationsCard = ({ filterData, handleOnChangeSearch }) => {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Body>
                <Grid container alignItems="end" justifyContent="flex-end">
                    <Grid size="grow">
                        <InputSearch
                            onChange={handleOnChangeSearch}
                            placeholder={t('Search user')}
                            value={filterData?.searchText}
                        />
                    </Grid>
                </Grid>
            </Card.Body>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    filterData: PropTypes.object,
    handleOnChangeSearch: PropTypes.func,
};

export default BulkOperationsCard;
